import { BdDialogProps } from '-/Base/BdDialog'
import { BdFormProps } from '-/Base/BdForm'
import type { PropType } from 'vue'
export const DialogFormProps = {
  ...BdDialogProps,
  ...BdFormProps,
  disableCache: {
    type: Boolean as PropType<boolean>,
    default: false
  },
  deepWatch: {
    type: Boolean as PropType<boolean>,
    default: false
  }
}
